import React, { useState, useEffect } from 'react';
import { Table, Input, Button } from 'reactstrap';

import LogInputRow from './LogInputRow';
import LogRow from './LogRow';

const Log = ( props ) => {
  const { headers, exercises, selectedIndex } = props;

  const renderHeaders = () => {
    return headers.map(header => {
      return (
        <th className="bg-corporate text-white text-center">{header.caption}</th>
      );
    })
  }

  const renderRows = () => {
    return exercises.map((exercise, index) => {
      if (exercise.id === selectedIndex) {
        return <LogInputRow key={index} headers={headers} exercise={exercise} />;
      } else {
        return <LogRow key={index} headers={headers} exercise={exercise} />
      }
    })
  }

  const renderFirstRow = () => {
    return headers.map(header => {
      return <td className="text-center" style={{fontSize: 16}}>{header.firstRowValue}</td>
    });
  }

  return (
    <Table responsive striped>
      <thead>
        <tr className="rounded-top">
          {renderHeaders()}
          <th className="bg-corporate text-white text-center"></th>
        </tr>
      </thead>
      <tbody>
        <tr>{renderFirstRow()}</tr>
        {renderRows()}
      </tbody>
    </Table>
  );
}

export default (Log);
